export default "__VITE_ASSET__Bsh_jbXt__"